<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/addresses/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          Create new
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'address'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/addresses`"
    />
  </v-container>
</template>

<script>
export default {
  name: "AddressList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Firstname', value: 'firstname' },
      { text: 'Lastname', value: 'lastname' },
      { text: 'Address', value: 'address_detail', sortable: false },
      { text: 'Sub-district', value: 'address_sub_district' },
      { text: 'District', value: 'address_district' },
      { text: 'Province', value: 'address_province' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['firstname', 'lastname', 'company_name', 'company_branch',
      'tax_id', 'address_detail', 'address_sub_district', 'address_district',
      'address_province', 'address_country', 'address_postal_code'],
    search_param: '',
    attribute_list: ['id', 'firstname', 'lastname', 'address_detail', 'address_sub_district', 'address_district', 'address_province'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
